import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { useSearchParams } from 'react-router-dom';
import { Axios } from '../../axios-instance';
import { BaseError } from '@utils/types/shared/base';
import {
  LicenseKey,
  LicenseKeyListResponse
} from '@utils/types/back-office/licensing';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';

export const ADMIN_LICENSE_KEYS_QUERY_KEY = 'adminLicenseKeys';

export const useGetAdminLicenseKeys = () => {
  const { searchParams } = useNewAppSearchParams();
  const [sp] = useSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;
  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const allQ = sp.getAll('q').filter(Boolean);

  const buildUrl = () => {
    const qp = new URLSearchParams();
    if (offset) qp.append('offset', String(offset));
    qp.append('limit', String(limit));
    if (sortField) qp.append('sort', sortField);
    if (sortDirection) qp.append('direction', sortDirection);
    allQ.forEach(v => qp.append('q', v));
    const qs = qp.toString();
    return `api/admin/licensing/keys${qs ? `?${qs}` : ''}`;
  };

  return useQuery<LicenseKeyListResponse, AxiosError<BaseError>>(
    [
      ADMIN_LICENSE_KEYS_QUERY_KEY,
      offset,
      limit,
      sortField,
      sortDirection,
      allQ.join(',')
    ],
    () =>
      Axios.get<LicenseKeyListResponse | LicenseKey[]>(buildUrl()).then(r => {
        const raw = r.data;
        if (Array.isArray(raw)) {
          return { result: raw, count: raw.length, total_results: raw.length };
        }
        return raw;
      }),
    {
      useErrorBoundary: false,
      keepPreviousData: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
};
